import { validate } from 'cnpj';
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from 'components/dataTableableEdit/BaseDataTableEdit';
import Estagio from 'model/producao/Estagio';
import EstagioRoteiro from 'model/producao/EstagioRoteiro';
import Roteiro from 'model/producao/Roteiro';
import { Column } from 'primereact/column';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import RoteiroService from 'service/producao/RoteiroService';
import { cnpjMask, cpfMask } from "utils/mask";
import "react-hook-form";
import {Controller, useForm} from "react-hook-form";
import { Label } from 'components/input/Label';
import { clear } from 'console';

const roteiroService = new RoteiroService();

export default function RoteiroCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, register, setFocus, formState: {errors} } = useForm(); 

    const inputNomeRef = useRef<any>(null);

    const [roteiro, setRoteiro] = useState<Roteiro>(new Roteiro(0, "", "", []));
    const [titulo, setTitulo] = useState<string>('Roteiro');
    const [estagiosDisponiveis, setEstagiosDisponiveis] = useState<Estagio[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        roteiroService.estagios().then(data => {
            setEstagiosDisponiveis(data);
        });
    }, []);


    function validar() {

        if(!roteiro.codigoRoteiro){
            setError("codigoRoteiro", {type: "manual", message:"Código é obrigatório"}, {shouldFocus: true});
            return false;
        }
        if (!roteiro.nome) {
            setError("nome", {type: "manual", message:"Nome é obrigatório"}, {shouldFocus: true});
            return false;
        }
        return true;
    }

    const estagioEditor = (options: any) => {
        return <Dropdown 
            value={options.rowData.estagio}
            options={estagiosDisponiveis} 
            optionLabel='nome'
            onChange={(e) => {
                options.rowData['estagio'] = e.target.value;
                let roteiroLocal = { ...roteiro };
                roteiro.estagios[options.rowIndex] = options.rowData;
                setRoteiro(roteiroLocal);
            }} 
            style={{ width: '100%' }} placeholder="Selecione um Estágio" />;
    }

    const editorPosicionamento = (options: any) => {
        return <InputNumber 
            value={options.rowData.sequenciaPosicionamento}
            onChange={(e) => {
                options.rowData['sequenciaPosicionamento'] = e.value;
                let roteiroLocal = { ...roteiro };
                roteiro.estagios[options.rowIndex] = options.rowData;
                setRoteiro(roteiroLocal);
            }} 
            style={{ width: '100%' }} />;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!roteiro.codigoRoteiro) {
                roteiroService.proximoCodigo().then((data) => {
                    setRoteiro({...roteiro, codigoRoteiro: data});
                    setFocus("nome");
                    clearErrors("codigoRoteiro")
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={roteiro} service={roteiroService} setModel={(value: Roteiro) => setRoteiro(value)} validar={() => validar()} urlService="/roteiro" pathCadastro="/roteiro" tituloPagina={'Roteiro'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        value={roteiro.codigoRoteiro} 
                        className={errors.codigoRoteiro ? "p-invalid" : ""}
                        onKeyDown={codigoKeyDown} 
                        style={{ width: '30%' }} 
                        {...register("codigoRoteiro", {
                            onChange: (e) => {
                                setRoteiro({ ...roteiro, codigoRoteiro: e.target.value})
                                clearErrors("codigoRoteiro")
                            }
                        })}
                    />
                </div>
                {errors.codigoRoteiro && errors.codigoRoteiro.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoRoteiro?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={roteiro.nome} 
                        className={errors.nome ? "p-invalid" : ""}
                        style={{ width: '30%' }} 
                        {...register("nome", {
                            onChange: (e) => {
                                setRoteiro({ ...roteiro, nome: e.target.value})
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Estágios</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Estágios"
                        getNewModel={() => new EstagioRoteiro()}
                        dataKey="key"
                        lista={roteiro.estagios ? roteiro.estagios : []}
                        setLista={(value: any) => setRoteiro({ ...roteiro, estagios: value })}
                        scrollable
                        scrollHeight='500px'
                        reordable
                        onRowReorder={(e) => {
                            e.value.forEach((item: any, index: number) => {
                                item.sequencial = index + 1;
                            });
                            if (roteiro) {
                                roteiro.estagios = e.value as EstagioRoteiro[];
                                setRoteiro({ ...roteiro });
                            }

                        }}
                    >
                        <Column rowReorder style={{ width: '3rem' }} />
                        <Column field="sequencial" header="Sequencial" style={{ width:'5rem' }} />
                        <Column field="estagio.codigoEstagio" header="Cód. Estágio"   style={{ width:'10rem' }} />
                        <Column field="estagio.nome" header="Nome Estágio" editor={estagioEditor} style={{ width:'35rem' }} />
                        <Column field="sequenciaPosicionamento" header="Seq. Posicionamento" editor={editorPosicionamento} />
                        
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
